import useIncreasingNumber from "@/hooks/useIncreasingNumber";
import { useRef } from "react";
import FontAwesomeSvg from "../SVG/Fontawesome";

const StatsV1Item = (props: { count: any; text: any }) => {
  const ref = useRef<HTMLDivElement>(null);
  const increasingNum = useIncreasingNumber(ref, parseInt(props.count));
  return (
    <div ref={ref} className='flex flex-col text-left'>
      <span className='font-bold text-xl whitespace-nowrap'>{`${Number(increasingNum).toLocaleString("en-IN")} +`}</span>
      <span className="text-gray-300 font-medium">{props.text}</span>
    </div>
  );
};

const StatsV1 = (props: {
  stats: {
    text: string;
    count: number;
    svg: string;
  }[];
}) => {
  return (
    <>
      {
        props.stats.map((item, index) => (
          <div className='p-2 w-full lg:basis-1/2 min-w-0' key={index}>
            <div className='card flex gap-2 items-center'>
              <div className='p-2'>
                <p className='text-justify'>
                  <FontAwesomeSvg name={item.svg} className="text-3xl text-accent fill-accent" />
                </p>
              </div>
              <StatsV1Item count={item.count} text={item.text} />
            </div>
          </div>
        ))
      }
    </>
  );
}

export default StatsV1;
